namespace('compass.group');

compass.require('compass.util.validate');

compass.group.BatchModifyRoomsWidget= compass.defineWidget(function BatchModifyRoomsWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;

	var fullDateFormat = compass.util.dateFormatter('ddd, mmm d, yyyy');
	var _isDefault = true;
	var cancelValidator;

	var _drawHeader = function(hotelName, numUnassignedRooms, blockName){
		return [
			d.div({className: 'title'}, _settings.batchModifyRoomsTitle),
			d.div({className: 'hotelName'}, hotelName),
			d.div({className: 'unassignedRoomCount'}, numUnassignedRooms + ' ' + (numUnassignedRooms === 1 ? _settings.labels.UnassignedRoomCount.singular : _settings.labels.UnassignedRoomCount.plural)),
			d.div({className: 'blockName'}, blockName)
		];
	};

	var _drawGroupedRooms = function() {
		var groupedRooms = [];
		_.each(_settings.blockData.unassignedRoomsInfo, function(group) {
			if (group.canCancel) {
				groupedRooms.push(d.div({ className: 'groupedRooms'},
					d.div( {className: 'group'},
						d.select({ name: 'roomsToKeep', className: 'currentReservationsDropdown'},
							_.map(_.range(group.count, -1, -1), function(option) {
								return d.option({value: option}, option);
							})
						).change(function() {
							if(_isDefault) {
								me.find('.cancelButton').removeClass('disabled');
								me.find('.cancelAllButton').removeClass('disabled');
								_isDefault = false;
							}
							compass.GA.trackEvent('Modify Unassigned', 'Adjust Value', 'Number of Rooms');
						}),
						d.div({ className: 'roomType' }, group.roomTypeBase.name),
						d.div({ className: 'groupedRoomsDivider' }),
						d.div({ className: 'datesAvailable' }, fullDateFormat(compass.util.parse.ISODateParser(group.arrive)) + ' - ' + fullDateFormat(compass.util.parse.ISODateParser(group.depart))),
						d.input({ name: 'blocked_room_id', type: 'hidden', disabled: true, value: group.blocked_room_id}),
						d.input({ name: 'arrive', type: 'hidden', disabled: true, value: group.arrive}),
						d.input({ name: 'depart', type: 'hidden', disabled: true, value: group.depart})
					)
				));
			}
		});

		return d.div({ className: 'groupedRoomsContainer'}, groupedRooms);
	};

	var _drawCancelWidget = function(container) {
		cancelValidator = new compass.validator({
			onValid : function (e) {
				e.removeClass('invalid');
				me.find('.cancelAllButton').removeClass('disabled');
			},
			onInvalid: function (e) {
				e.addClass('invalid');
				me.find('.cancelAllButton').addClass('disabled');
			}
		});
		var cancelWidgetLabels = {
			'reasons': {
				'label': "Quantity updated because",
				'hint': 'Reason is required'
			},
			'notes': {
				'label': 'Any comments to help us out?',
				'hint': ''
			}
		};

		var cancelWidget = new compass.hotel.CancelRoomWidget(container, { 
			hideHeader:true, 
			showSecondaryButton: true, 
			validator: cancelValidator, 
			labels:cancelWidgetLabels,
			cancelReasons : _settings.cancelReasons,
			cancelFee: _settings.cancelFee,
			hasActiveCancelFee : _settings.blockData.hasActiveCancelFee 
		});


		cancelWidget.bind('CancelRoomWidget.showPolicies', function(event, eventData) {
			me.trigger('BatchModifyRoomsWidget.showPolicies', {blockedRoomIds : _settings.blockData.unassignedRoomsInfo[0].blocked_room_id});
		});

		return container;
	};

	var _haveCardsFailedProcessing = function() {
		return _.some(_settings.blockData.unassignedRoomsInfo, function(room) {
			return room.obligationStatus === 'FAILED';
		});
	};

	this.render = function (widgetElem) {
		var cancelWidgetContainer = d.div();

		widgetElem.append(_drawHeader(_settings.hotelData.hotelBase.name, _settings.blockData.numUnassignedRooms, _settings.blockData.blockName));
		widgetElem.append([
			_drawGroupedRooms(),
			_haveCardsFailedProcessing() ? "" : d.div({ className: 'batchModifyInstructions'}, _settings.batchModifyInstructions),
			_haveCardsFailedProcessing() ? "" : _drawCancelWidget(cancelWidgetContainer),
			_haveCardsFailedProcessing() ? d.div({ className: 'failedCardInstructions'}, _settings.failedCardInstructions) : ""
		]);

		_haveCardsFailedProcessing() ? widgetElem.find('select[name="roomsToKeep"]').attr('disabled', 'disabled') : "";

		var cancelButton = widgetElem.find('.cancelButton');
		var cancelAllButton = widgetElem.find('.cancelAllButton');
		var checkbox = widgetElem.find('.cancelFeeCheckbox');

		widgetElem.bind('CancelRoomWidget.Cancel', function (event, values) {
			if(!cancelButton.hasClass('disabled') && !cancelAllButton.hasClass('disabled')) {
				var fields = cancelValidator.validate();
				if (fields.length > 0) {
					return;
				}
				cancelButton.addClass('disabled');
				cancelAllButton.addClass('disabled');
			}
			if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
				compass.GA.trackEvent('Modify Unassigned', 'Update', 'Update Quantity');
				
				me.trigger('Dialog.removeCloseButton');
				me.trigger('BatchModifyRoomsWidget.Cancel', {
					roomsToCancel: me.grabValues(),
					reason: values.reason,
					notes: values.notes
				});
			}
		});
		widgetElem.bind('CancelRoomWidget.cancelReasonsChanged', function(event) {
			if (checkbox.length === 0 || checkbox.is(":checked")) {
				checkbox.removeClass('invalid');
				cancelButton.removeClass('disabled');
				cancelAllButton.removeClass('disabled');
			} else {
				checkbox.addClass("invalid");
			}
		});
		widgetElem.bind('CancelRoomWidget.cancelFeeCheckboxChanged', function(event) {
			if (checkbox.is(':checked')) {
				checkbox.removeClass('invalid');
				cancelButton.removeClass('disabled');
				cancelAllButton.removeClass('disabled');
			} else {
				checkbox.addClass('invalid');
			}
		});
		widgetElem.bind('CancelRoomWidget.CancelAll', function (event, values) {
			if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
				compass.GA.trackEvent('Modify Unassigned', 'Update', 'Cancel All Rooms');

				me.trigger('Dialog.removeCloseButton');
				me.trigger('BatchModifyRoomsWidget.Cancel', {
					roomsToCancel: _.map(me.grabValues(), function(value) {
						return {
							blocked_room_id: value.blocked_room_id,
							arrive: value.arrive,
							depart: value.depart,
							roomsToKeep: 0
						};
					}),
					reason: values.reason,
					notes: values.notes
				});
			}
		});
	};

	this.grabValues = function() {
		var groupedRooms = me.find('.groupedRooms .group');
		var values = _.map(groupedRooms, function(groupedRoom) {
			var inputs = $(groupedRoom).find(':input');
			var vals = {};
			_.each(inputs, function(input) {
				vals[input.name] = input.value;
			});
			return vals;
		});
		return values;
	};
}, {
	WUID: 'BatchModifyRoomsWidget',
	widgetName: 'BatchModifyRoomsWidget',
	batchModifyRoomsTitle: 'Modify Unassigned Rooms',
	batchModifyInstructions: 'Select the number of rooms you want to keep to Update Quantity or Cancel All Rooms that are listed above.',
	failedCardInstructions: 'We were unable to process the credit card for some of these rooms. You must update the card before you can edit these rooms.',
	blockData: {},
	hotelData: {},
	labels: {
		UnassignedRoomCount: {
			singular: 'Unassigned Room',
			plural: 'Unassigned Rooms'
		}
	},
	cancelReasons: []
});
